<div class="form-wrapper" [class.inline]="formInline">
  <ion-label [ngClass]="{ uppercase: uppercase }" class="ion-text-start">
    {{ label }}
  </ion-label>
  @if (_options?.length > 0) {
    <ion-radio-group
      [class.row]="!fullWidth"
      [formControl]="control"
    >
      @for (item of _options; track item.value) {
        <ion-item lines="none" class="ion-no-padding">
          <ion-radio
            [disabled]="readonly"
            color="primary"
            slot="start"
            [name]="item.value"
            [value]="item.value"
            mode="md"
            [ariaLabel]="item.label"
            [attr.data-value]="item.value"
            labelPlacement="end"
          >
            <div class="ion-text-wrap">{{ item.label }}</div>
          </ion-radio>
        </ion-item>
      }
    </ion-radio-group>
  }
</div>

@if (hasErrors) {
  <div class="error-wrapper">
    <c-validation-error [validationMessages]="control.errors" [controlValue]="control.value" />
  </div>
}
